/* eslint-disable max-lines, no-undef, react/destructuring-assignment, react/no-unused-state, sort-keys, sort-vars */

import PropTypes from "prop-types";
import React from "react";
import {clearAllFilters} from "../../../actions";
import {connect} from "react-redux";

class FilterPills extends React.Component {

  static propTypes = {
    "clearAllFilters": PropTypes.func.isRequired,
    "doFilter": PropTypes.func.isRequired,
    "filters": PropTypes.array.isRequired,
    "handleClick": PropTypes.func.isRequired,
    "selectedFilters": PropTypes.array.isRequired
  };

  filterPill = filterType =>
    <div
      className="filter-pill mr8 mb16"
      id={filterType.key}
      key={filterType.key}
      onClick={this.props.handleClick}
      tabIndex="0"
      title={filterType.displayName}
    >
      <div className="x-icon" />
      <div>
        {filterType.key.indexOf("size") !== -1 && "Size "}
        {" "}
        {filterType.displayName}
      </div>
    </div>;

  render () {
    const {clearAllFilters, selectedFilters} = this.props, // eslint-disable-line
      kindFilter = selectedFilters.filter(selectedFilter =>
        selectedFilter.key.indexOf("kind") === 0 && selectedFilter.key.split("-").length === 2),
      selectedNonKindFilters = selectedFilters.filter((selectedFilter) => {
        const {key} = selectedFilter;
        return (!(key.indexOf("kind") === 0) || key.split("-").length !== 2) && !(key.indexOf("sort") === 0);
      });

    return (
      <div className="filterPills pl24">
        <div className="filter-pills-title">
          <span className="filters-section-title styled_h5 mt0">
            {kindFilter.length > 0
              ? kindFilter[0].displayName
              : "All Jewelry"
            }
          </span>
        </div>
        <div className="clickable-filter-pills">
          <div>
            {selectedNonKindFilters.map(filterName => this.filterPill(filterName))}
            {selectedFilters.length > 0 &&
              <div
                className="filter-pill clear-all-filters"
                onClick={clearAllFilters}
              >
                Clear All
              </div>}
          </div>
        </div>

      </div>
    );
  }
}

const mapStoreToProps = state => ({"selectedFilters": state.selectedFilters || []});


export default connect(mapStoreToProps, {clearAllFilters})(FilterPills);
